<template>
	<div class="cannotAccess">
		<div class="h3">
			<p>親愛的用戶：</p>
			本網站不支持來自中國大陸地區的用戶。訪問前，請確認您不是來自上述國家或地區。
		</div>
		<div class="h3">
			<p>Dear User</p>
			This website does notsupport users from maniniland China.Please confirm that you are not from the
			above
			countries or regions before visiting.
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title: ''
			}
		},
		mounted() {},
		methods: {}
	}
</script>

<style lang="less">
	html,
	body {
		background: #000;
	}

	#app {
		width: 100vw;
		height: 100vh;
	}

	.cannotAccess {
		width: 90%;
		margin-left: 5%;
		top: 50%;
		transform: translateY(-50%);
		position: absolute;

		.h3 {
			font-size: 32px;
			line-height: 50px;
			color: #fff;
			margin-bottom: 20px;

			p {
				font-size: 36px;
				margin-bottom: 10px;
			}
		}
	}
</style>